import { createSelector } from 'reselect';

const key = 'checkout';
const domains = {
    position: (state) => state.global[key].position,
    userId: (state) => state.global[key].userId,
    contactInfo: (state) => state.global[key].contactInfo,
    order: (state) => state.global[key].order,
};

const selectorPosition = createSelector([domains.position], (position) => position);

const selectorUserId = createSelector([domains.userId], (userId) => userId);

const selectorContactInfo = createSelector([domains.contactInfo], (contactInfo) => contactInfo);

const selectorOrder = createSelector([domains.order], (order) => order);

const makeSelectPosition = () => selectorPosition;
const makeSelectUserId = () => selectorUserId;
const makeSelectContactInfo = () => selectorContactInfo;
const makeSelectOrderInfo = () => selectorOrder;

export { makeSelectPosition, makeSelectUserId, makeSelectContactInfo, makeSelectOrderInfo };
